import { createDefaultFileDownloadSettings, normalizeHeaderFiles } from './localFile.js';

export const FILE_HEADER_TYPE = 'file-header';

export function getFileHeaderDefaults(extra = {}) {
	return normalizeFileHeaderData({
		items: [],
		downloadSettings: createDefaultFileDownloadSettings(),
		...extra,
	});
}

export function normalizeFileHeaderData(data = {}) {
	return normalizeHeaderFiles(data);
}

export function isFileHeaderBlock(type) {
	return type === FILE_HEADER_TYPE;
}
